<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="人工成本明细">
        <div slot="content">
          <edit-data-table
            :head="tableHead"
            :data.sync="tableData"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :showAdd="showAdd"
            height=""
          >
            <template #person="{row}">
              <span>{{row.person ? row.person.name:''}}</span>
            </template>
            <template #personEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.person"
                @confirm="(val) => {row.personnelId = val.id}"
              ></data-box>
            </template>
            <template #projectRole="{row}">
              <span>{{row.projectRole? row.projectRole.name:''}}</span>
            </template>
            <template #projectRoleEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectRole"
                @confirm="(val) => {row.roleId = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delBizArtificial($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="费用明细">
        <div slot="content">
          <edit-data-table
            :head="tableHead2"
            :data.sync="tableData2"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :showAdd="showAdd"
            height=""
          >
            <template #projectBudget="{row}">
              <span>{{row.projectBudget? row.projectBudget.name:''}}</span>
            </template>
            <template #projectBudgetEdit="{row}">
              <data-box
                hostUrl="/bsProjectBudget"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectBudget"
                @confirm="(val) => {row.projectBudgetId = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delBizCostDetail($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="奖金分配方案">
        <div slot="content">
          <edit-data-table
            :head="tableHead3"
            :data.sync="tableData3"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :showAdd="showAdd"
            height=""
          >
            <template #projectRole="{row}">
              <span>{{row.projectRole? row.projectRole.name:''}}</span>
            </template>
            <template #projectRoleEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectRole"
                @confirm="(val) => {row.projectRoleId = val.id}"
              ></data-box>
            </template>
            <template #person="{row}">
              <span>{{row.person? row.person.name:''}}</span>
            </template>
            <template #personEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.person"
                @confirm="(val) => {row.personnelId = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delBizBonusScheme($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button
          class="btn-submit"
          @click="save(1)"
        >保存</el-button>
        <el-button
          class="btn-submit"
          @click="submit(2)"
        >提交</el-button>
        <el-button
          class="btn-cancel"
          @click="cancel"
        >取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
// import FormTable from '../../components/form-table'
import {
  sellProjectDetail,
  addSellProject,
  editSellProject,
  delSellBizArtificial,
  delSellBonusScheme,
  delSellCostBudget
} from "@/api/basic";
export default {
  components: {
    FoldedPanel,
    DataBox,
  },
  data() {
    return {
      id: "",
      form: {},
      showAdd: true,
      title2: '费用明细',
      formConfig: {
        formItemList: [
          // {
          //   type: "input",
          //   key: "clientId",
          //   label: "单据编号",
          //   value: "",
          //   span: 8
          // },
          {
            key: "projectNumber",
            label: "项目号",
            value: "",
            type: "input",
            span: 8,
            disabled: true
          },
          {
            label: "项目名",
            key: "projectName",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bsProject",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            label: "立项类型",
            key: "projectApprovalType",
            type: "select",
            span: 8,
            options: [
              {
                value: "0",
                label: "类型一"
              },
              {
                value: "1",
                label: "类型一"
              },
              {
                value: "2",
                label: "类型三"
              }
            ]
          },
          // {
          //   type: "input",
          //   key: "address",
          //   label: "来源单据号",
          //   value: "",
          //   span: 8
          // },
          {
            key: "operator",
            label: "经营人",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            type: "input",
            key: "businessOpportunitiesNumber",
            label: "商机号",
            value: "",
            span: 8
          },
          {
            key: "projectLeader",
            label: "项目负责人",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            span: 8,
            type: "number",
            key: "artificialCostBudget",
            label: "人工成本预算",
            value: ""
          },
          {
            span: 8,
            type: "number",
            key: "artificialCost",
            label: "人工成本耗费",
            value: ""
          },
          {
            span: 8,
            type: "number",
            key: "costBudget",
            label: "费用预算",
            value: ""
          },
          {
            span: 8,
            type: "number",
            key: "costBudgetCost",
            label: "费用预算耗费",
            value: ""
          },
          {
            span: 8,
            type: "date",
            key: "planDate",
            label: "计划成单日期",
            value: "",
            valueFormat: "yyyy-MM-dd"
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注",
            span: 16
          }
        ]
      },
      tableHead: [
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default" }
        },
        {
          label: "结算单价",
          prop: "settlementPrice",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "项目角色",
          prop: "projectRole",
          editRender: { type: "default" }
        },
        {
          label: "项目消耗人天",
          prop: "projectCostDay",
          editRender: { type: "default", name: "ElInput" ,disabled: false }
        },
        {
          label: "项目人工耗费",
          prop: "projectArtificialCost",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead2: [
        {
          label: "预算项目",
          prop: "projectBudget",
          editRender: { type: "default" }
        },
        {
          label: "预算金额",
          prop: "budgetAmount",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "耗费金额",
          prop: "costAmount",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "结余金额",
          prop: "balance",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableHead3: [
        {
          label: "项目角色",
          prop: "projectRole",
          editRender: { type: "default" }
        },
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default" }
        },
        {
          label: "分配比例",
          prop: "allocationProportion",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "发放条件",
          prop: "distributingConditions",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ]
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      sellProjectDetail(this.id).then(res => {
        console.log(res);
        const form = res.data.bizSellProject;
        form.projectName = { id: form.projectNumber, name: form.projectName };
        form.operator = {
          id: form.operator,
          name: form.business ? form.business.name : ""
        };
        form.projectLeader = { id: form.projectLeader, name: form.leader };
        this.form = form;
        this.tableData = res.data.bizArtificialCost;
        console.log(this.tableData);
        this.tableData2 = res.data.bizCostDetail;
        this.tableData3 = res.data.bizBonusScheme;
      });
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    // 保存
    save(status) {
      if (this.form.operator) {
        this.form.operatorName = this.form.operator.name;
        this.form.operator = this.form.operator.id;
      }
      if (this.form.projectName) {
        this.form.projectName = this.form.projectName.name;
        // this.form.projectNumber = this.form.projectName.id;
      }
      if (this.form.projectLeader) {
        this.form.projectLeaderName = this.form.projectLeader.name;
        this.form.projectLeader = this.form.projectLeader.id;
      }
      this.form.billState = status
      const obj = {};
      obj.bizSellProject = this.form;
      obj.bizArtificialCost = this.tableData;
      obj.bizCostDetail = this.tableData2;
      obj.bizBonusScheme = this.tableData3;
      if (this.form.id) {
        editSellProject(obj).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$notify({
              title: "保存成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      } else {
        addSellProject(obj).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$notify({
              title: "保存成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      }
    },
    // 提交
    submit(status) {
      console.log(this.form);
      if (this.form.operator) {
        this.form.operatorName = this.form.operator.name;
        this.form.operator = this.form.operator.id;
      }
      if (this.form.projectName) {
        this.form.projectName = this.form.projectName.name;
        // this.form.projectNumber = this.form.projectName.id;
      }
      if (this.form.projectLeader) {
        this.form.projectLeaderName = this.form.projectLeader.name;
        this.form.projectLeader = this.form.projectLeader.id;
      }
       this.form.billState = status
      const obj = {};
      obj.bizSellProject = this.form;
      obj.bizArtificialCost = this.tableData;
      obj.bizCostDetail = this.tableData2;
      obj.bizBonusScheme = this.tableData3;
      if (this.form.id) {
        editSellProject(obj).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$notify({
              title: "保存成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      } else {
        addSellProject(obj).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$notify({
              title: "保存成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      }
    },
    delBizArtificial(index) {
      if (this.tableData[index].id) {
        delSellBizArtificial(this.tableData[index].id);
        this.tableData.splice(index, 1);
      } else {
        this.tableData.splice(index, 1);
      }
    },
    delBizCostDetail(index) {
      console.log('index=>',index)
        console.log('index2=>',this.tableData2[index])
      if (this.tableData2[index].id) {
        delSellCostBudget(this.tableData2[index].id);
        this.tableData2.splice(index, 1);
      } else {
        this.tableData2.splice(index, 1);
      }
    },
    delBizBonusScheme(index) {
      if (this.tableData3[index].id) {
        delSellBonusScheme(this.tableData3[index].id);
        this.tableData3.splice(index, 1);
      } else {
        this.tableData3.splice(index, 1);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.button {
  padding-top: 20px;
  text-align: right;
  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }
  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>